import moment from "moment";

import { selectLessonsReportsFilter, setCampaignDateFromForLessonsReports, setCampaignDateToForLessonsReports, setCompanyEnabledForLessonsReports, setCompanyIdForLessonsReports, setGroupIdForLessonsReports, setInOutFromCompanyAccumulatedDateFromForLessonsReports, setInOutFromCompanyAccumulatedDateToForLessonsReports, setInOutFromCompanyDateFromForLessonsReports, setInOutFromCompanyDateToForLessonsReports, setUsersAgeForLessonsReports, setUsersGenderForLessonsReports } from "../../../features/reports/learning/lessons/filter";
import { selectUserReportsFilter, setCampaignDateFromForUserReports, setCampaignDateToForUserReports, setCompanyEnabledForUserReports, setCompanyIdForUserReports, setGroupIdForUserReports, setInOutFromCompanyAccumulatedDateFromForUserReports, setInOutFromCompanyAccumulatedDateToForUserReports, setInOutFromCompanyDateFromForUserReports, setInOutFromCompanyDateToForUserReports, setUsersAgeForUserReports, setUsersGenderForUserReports } from "../../../features/reports/users/filter";
import { selectTopicsReportsFilter, setCampaignDateFromForTopicsReports, setCampaignDateToForTopicsReports, setCompanyEnabledForTopicsReports, setCompanyIdForTopicsReports, setGroupIdForTopicsReports, setInOutFromCompanyAccumulatedDateFromForTopicsReports, setInOutFromCompanyAccumulatedDateToForTopicsReports, setInOutFromCompanyDateFromForTopicsReports, setInOutFromCompanyDateToForTopicsReports, setUsersAgeForTopicsReports, setUsersGenderForTopicsReports } from "../../../features/reports/learning/topics/filter";
import { selectCoursesReportsFilter, setCampaignDateFromForCoursesReports, setCampaignDateToForCoursesReports, setCompanyEnabledForCoursesReports, setCompanyIdForCoursesReports, setGroupIdForCoursesReports, setInOutFromCompanyAccumulatedDateFromForCoursesReports, setInOutFromCompanyAccumulatedDateToForCoursesReports, setInOutFromCompanyDateFromForCoursesReports, setInOutFromCompanyDateToForCoursesReports, setUsersAgeForCoursesReports, setUsersGenderForCoursesReports } from "../../../features/reports/learning/courses/filter";
import { selectKnowledgeBaseReportsFilter, setCampaignDateFromForKnowledgeBaseReports, setCampaignDateToForKnowledgeBaseReports, setCompanyEnabledForKnowledgeBaseReports, setCompanyIdForKnowledgeBaseReports, setGroupIdForKnowledgeBaseReports, setInOutFromCompanyAccumulatedDateFromForKnowledgeBaseReports, setInOutFromCompanyAccumulatedDateToForKnowledgeBaseReports, setInOutFromCompanyDateFromForKnowledgeBaseReports, setInOutFromCompanyDateToForKnowledgeBaseReports, setUsersAgeForKnowledgeBaseReports, setUsersGenderForKnowledgeBaseReports } from "../../../features/reports/knowledgeBase/filter";
import { selectCampaignsReportsFilter, setCampaignDateFromForCampaignsReports, setCampaignDateToForCampaignsReports, setCompanyEnabledForCampaignsReports, setCompanyIdForCampaignsReports, setGroupIdForCampaignsReports, setInOutFromCompanyAccumulatedDateFromForCampaignsReports, setInOutFromCompanyAccumulatedDateToForCampaignsReports, setInOutFromCompanyDateFromForCampaignsReports, setInOutFromCompanyDateToForCampaignsReports, setUsersAgeForCampaignsReports, setUsersGenderForCampaignsReports } from "../../../features/reports/Campaigns/filter";
import { selectCaseReportsFilter, setCampaignDateFromForCaseReports, setCampaignDateToForCaseReports, setCompanyEnabledForCaseReports, setCompanyIdForCaseReports, setGroupIdForCaseReports, setInOutFromCompanyAccumulatedDateFromForCaseReports, setInOutFromCompanyAccumulatedDateToForCaseReports, setInOutFromCompanyDateFromForCaseReports, setInOutFromCompanyDateToForCaseReports, setUsersAgeForCaseReports, setUsersGenderForCaseReports } from "../../../features/reports/case/filter";
import { ReportTypes } from "../MenuAndRoutes";
import { GenderEnum } from "../../../features/users/usersSlice";
import { ExtendedStatus } from "../Company/StatusSelector";
import { selectCompanyReportsFilter, setCampaignDateFromForCompanyReports, setCampaignDateToForCompanyReports, setCompanyEnabledForCompanyReports, setCompanyIdForCompanyReports, setGroupIdForCompanyReports, setInOutFromCompanyAccumulatedDateFromForCompanyReports, setInOutFromCompanyAccumulatedDateToForCompanyReports, setInOutFromCompanyDateFromForCompanyReports, setInOutFromCompanyDateToForCompanyReports, setUsersAgeForCompanyReports, setUsersGenderForCompanyReports } from "../../../features/reports/company/filter";

export enum AgeGroupsEnum {
  young = "young",
  youngAdult = "youngAdult",
  adult = "adult",
  mature = "mature",
}

export interface IFilterForReports {
  companyId?: string;
  companyEnabled?: ExtendedStatus;
  groupId?: string;
  campaignDates?: {
    from: moment.Moment | null;
    to: moment.Moment | null;
  };
  inOutFromCompanyDates?: {
    from: moment.Moment | null;
    to: moment.Moment | null;
  };
  inOutFromCompanyAccumulatedDates?: {
    from: moment.Moment | null;
    to: moment.Moment | null;
  };
  usersGender?: GenderEnum;
  usersAge?: AgeGroupsEnum;
}

export const getSelectorsAndSetters = (reportType?: ReportTypes) => {
  switch (reportType) {
    case ReportTypes.Users:
      return {
        setCampaignDateFrom: setCampaignDateFromForUserReports,
        setCampaignDateTo: setCampaignDateToForUserReports,
        setCompanyEnabled: setCompanyEnabledForUserReports,
        setCompanyId: setCompanyIdForUserReports,
        setGroupId: setGroupIdForUserReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForUserReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForUserReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForUserReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForUserReports,
        setUsersGender: setUsersGenderForUserReports,
        setUsersAge: setUsersAgeForUserReports,
        selectFilter: selectUserReportsFilter,
      };
    case ReportTypes.Lessons:
      return {
        setCampaignDateFrom: setCampaignDateFromForLessonsReports,
        setCampaignDateTo: setCampaignDateToForLessonsReports,
        setCompanyEnabled: setCompanyEnabledForLessonsReports,
        setCompanyId: setCompanyIdForLessonsReports,
        setGroupId: setGroupIdForLessonsReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForLessonsReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForLessonsReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForLessonsReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForLessonsReports,
        setUsersGender: setUsersGenderForLessonsReports,
        setUsersAge: setUsersAgeForLessonsReports,
        selectFilter: selectLessonsReportsFilter,
      }
    case ReportTypes.Topics:
      return {
        setCampaignDateFrom: setCampaignDateFromForTopicsReports,
        setCampaignDateTo: setCampaignDateToForTopicsReports,
        setCompanyEnabled: setCompanyEnabledForTopicsReports,
        setCompanyId: setCompanyIdForTopicsReports,
        setGroupId: setGroupIdForTopicsReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForTopicsReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForTopicsReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForTopicsReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForTopicsReports,
        setUsersGender: setUsersGenderForTopicsReports,
        setUsersAge: setUsersAgeForTopicsReports,
        selectFilter: selectTopicsReportsFilter,
      }
    case ReportTypes.Courses:
      return {
        setCampaignDateFrom: setCampaignDateFromForCoursesReports,
        setCampaignDateTo: setCampaignDateToForCoursesReports,
        setCompanyEnabled: setCompanyEnabledForCoursesReports,
        setCompanyId: setCompanyIdForCoursesReports,
        setGroupId: setGroupIdForCoursesReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForCoursesReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForCoursesReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForCoursesReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForCoursesReports,
        setUsersGender: setUsersGenderForCoursesReports,
        setUsersAge: setUsersAgeForCoursesReports,
        selectFilter: selectCoursesReportsFilter,
      }
    case ReportTypes.KnowledgeBase:
      return {
        setCampaignDateFrom: setCampaignDateFromForKnowledgeBaseReports,
        setCampaignDateTo: setCampaignDateToForKnowledgeBaseReports,
        setCompanyEnabled: setCompanyEnabledForKnowledgeBaseReports,
        setCompanyId: setCompanyIdForKnowledgeBaseReports,
        setGroupId: setGroupIdForKnowledgeBaseReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForKnowledgeBaseReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForKnowledgeBaseReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForKnowledgeBaseReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForKnowledgeBaseReports,
        setUsersGender: setUsersGenderForKnowledgeBaseReports,
        setUsersAge: setUsersAgeForKnowledgeBaseReports,
        selectFilter: selectKnowledgeBaseReportsFilter,
      }
    case ReportTypes.Campaigns:
      return {
        setCampaignDateFrom: setCampaignDateFromForCampaignsReports,
        setCampaignDateTo: setCampaignDateToForCampaignsReports,
        setCompanyEnabled: setCompanyEnabledForCampaignsReports,
        setCompanyId: setCompanyIdForCampaignsReports,
        setGroupId: setGroupIdForCampaignsReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForCampaignsReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForCampaignsReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForCampaignsReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForCampaignsReports,
        setUsersGender: setUsersGenderForCampaignsReports,
        setUsersAge: setUsersAgeForCampaignsReports,
        selectFilter: selectCampaignsReportsFilter,
      }
    case ReportTypes.Cases:
      return {
        setCampaignDateFrom: setCampaignDateFromForCaseReports,
        setCampaignDateTo: setCampaignDateToForCaseReports,
        setCompanyEnabled: setCompanyEnabledForCaseReports,
        setCompanyId: setCompanyIdForCaseReports,
        setGroupId: setGroupIdForCaseReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForCaseReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForCaseReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForCaseReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForCaseReports,
        setUsersGender: setUsersGenderForCaseReports,
        setUsersAge: setUsersAgeForCaseReports,
        selectFilter: selectCaseReportsFilter,
      }
    case ReportTypes.Companies:
      return {
        setCampaignDateFrom: setCampaignDateFromForCompanyReports,
        setCampaignDateTo: setCampaignDateToForCompanyReports,
        setCompanyEnabled: setCompanyEnabledForCompanyReports,
        setCompanyId: setCompanyIdForCompanyReports,
        setGroupId: setGroupIdForCompanyReports,
        setInOutFromCompanyDateFrom: setInOutFromCompanyDateFromForCompanyReports,
        setInOutFromCompanyDateTo: setInOutFromCompanyDateToForCompanyReports,
        setInOutFromCompanyAccumulatedDateFrom: setInOutFromCompanyAccumulatedDateFromForCompanyReports,
        setInOutFromCompanyAccumulatedDateTo: setInOutFromCompanyAccumulatedDateToForCompanyReports,
        setUsersGender: setUsersGenderForCompanyReports,
        setUsersAge: setUsersAgeForCompanyReports,
        selectFilter: selectCompanyReportsFilter,
      }
  }
}